import { render, staticRenderFns } from "./ReinbursementResume.vue?vue&type=template&id=fb53ee2c&scoped=true"
import script from "./ReinbursementResume.vue?vue&type=script&lang=js"
export * from "./ReinbursementResume.vue?vue&type=script&lang=js"
import style0 from "./ReinbursementResume.vue?vue&type=style&index=0&id=fb53ee2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb53ee2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb53ee2c')) {
      api.createRecord('fb53ee2c', component.options)
    } else {
      api.reload('fb53ee2c', component.options)
    }
    module.hot.accept("./ReinbursementResume.vue?vue&type=template&id=fb53ee2c&scoped=true", function () {
      api.rerender('fb53ee2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/components/details/ReinbursementResume.vue"
export default component.exports